import endpoints from '../endpoints'
import axios from 'axios'
import _ from 'lodash'

const state = {
  content: {},
  searchQuery: '',
  lastUpdate: null
}

const getters = {
  getMenu: state => state.content,
  getSearchQuery: state => state.searchQuery
}

const actions = {
  loadMenu ({ state, commit }, { hostId, callback, forceReload }) {
    let expire = new Date()
    expire.setMinutes(expire.getMinutes() - 10)

    if (
      typeof this.state.menu.content.host !== 'undefined' &&
      Number(_.get(this.state.menu, 'content.host.id')) === Number(hostId) &&
      this.state.menu.lastUpdate > expire &&
      !forceReload
    ) {
      console.log('using cached menu from ' + this.state.menu.lastUpdate)

      if (typeof callback === 'function') callback()
      return
    }

    axios.post(endpoints.menu, { 'hostId': hostId })
      .then(response => {
        commit('setMenu', response.data)
        if (typeof callback === 'function') callback()
      })
      .catch(e => {
        console.log(['failed loading menu', e])
      })
  }
}

const mutations = {
  setMenu (state, menuResponse) {
    state.content = menuResponse
    state.lastUpdate = new Date()
  },

  setSearchQuery (state, searchQuery) {
    state.searchQuery = searchQuery
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/menu.js